import * as React from 'react'
import { SVGProps } from 'react'

// Icon Categories/Podcasts from "icons" page (Figma)
export const SvgReactComponent = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={24}
        height={24}
        viewBox="0 0 24 24"
        {...props}
    >
        <path d="M18.157 9.5h-.626a.626.626 0 0 0-.627.625V12c0 2.922-2.525 5.266-5.513 4.976-2.604-.254-4.511-2.589-4.511-5.199v-1.652a.626.626 0 0 0-.627-.625h-.626a.626.626 0 0 0-.627.625v1.569c0 3.501 2.505 6.623 5.952 7.097v1.334H8.76a.626.626 0 0 0-.626.625v.625c0 .345.28.625.626.625h6.266c.346 0 .626-.28.626-.625v-.625a.626.626 0 0 0-.626-.625h-2.193v-1.32c3.356-.459 5.952-3.332 5.952-6.805v-1.875a.626.626 0 0 0-.627-.625Zm-6.265 6.25a3.755 3.755 0 0 0 3.76-3.75H12.31c-.23 0-.418-.14-.418-.313v-.624c0-.173.187-.313.418-.313h3.341V9.5H12.31c-.23 0-.418-.14-.418-.313v-.624c0-.173.187-.313.418-.313h3.341V7H12.31c-.23 0-.418-.14-.418-.313v-.625c0-.172.187-.312.418-.312h3.341A3.755 3.755 0 0 0 11.891 2a3.755 3.755 0 0 0-3.758 3.75V12a3.755 3.755 0 0 0 3.759 3.75Z"/>
    </svg>
);
